/**
 * CL-372A — Property Intelligence Tools hub tab routing (?tab=).
 * CL-393C: Full research UI until migrated into property workspace Intelligence tab.
 * CL-397C: Saved search + Sale prep moved to Search-owned routes / left nav.
 */

import { SAVED_WORKSPACE_ROUTE } from "./clientRESavedWorkspace";
import { SALE_PREP_ROUTE } from "./clientRESalePrep";

/** Keep in sync with MY_PROPERTY_INTELLIGENCE_TOOLS_PATH in propertyIntelligenceRoutes.js */
const MY_PROPERTY_INTELLIGENCE_TOOLS_PATH = "/client-portal/real-estate/my-property";

export const MY_PROPERTIES_TABS = [
  { id: "overview", label: "Overview" },
  { id: "dna", label: "Property DNA" },
  { id: "market", label: "Market" },
  { id: "neighborhood", label: "Neighborhood" },
  { id: "documents", label: "Documents" },
];

const TAB_IDS = new Set(MY_PROPERTIES_TABS.map((t) => t.id));

export const MY_PROPERTIES_DEFAULT_TAB = "overview";

export const MY_PROPERTIES_HUB_PATH = MY_PROPERTY_INTELLIGENCE_TOOLS_PATH;

export function normalizeMyPropertiesTab(value) {
  const key = String(value ?? "").trim().toLowerCase();
  return TAB_IDS.has(key) ? key : MY_PROPERTIES_DEFAULT_TAB;
}

export function buildMyPropertiesHubPath(tab, extraSearch = "") {
  const normalized = normalizeMyPropertiesTab(tab);
  const params = new URLSearchParams(extraSearch.startsWith("?") ? extraSearch.slice(1) : extraSearch);
  params.set("tab", normalized);
  const q = params.toString();
  return q ? `${MY_PROPERTIES_HUB_PATH}?${q}` : `${MY_PROPERTIES_HUB_PATH}?tab=${normalized}`;
}

/** Legacy account Property DNA → hub DNA tab (preserves prefill and other params). */
export function buildMyPropertiesDnaRedirectPath(search = "") {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.set("tab", "dna");
  const q = params.toString();
  return q ? `${MY_PROPERTIES_HUB_PATH}?${q}` : buildMyPropertiesHubPath("dna");
}

/** Legacy account My market → hub Market tab. */
export function buildMyPropertiesMarketRedirectPath(search = "") {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.set("tab", "market");
  const q = params.toString();
  return q ? `${MY_PROPERTIES_HUB_PATH}?${q}` : buildMyPropertiesHubPath("market");
}

/** Legacy saved tab /saved route → Search-owned saved workspace. */
export function buildMyPropertiesSavedRedirectPath(search = "") {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.delete("tab");
  const q = params.toString();
  return q ? `${SAVED_WORKSPACE_ROUTE}?${q}` : SAVED_WORKSPACE_ROUTE;
}

/** Legacy sale-prep tab → dedicated Sale prep route. */
export function buildMyPropertiesSalePrepRedirectPath() {
  return SALE_PREP_ROUTE;
}
